import FavoriteApi from "@/services/api/favoritesApi";
import RetailerApi from "@/services/api/retailerApi";
import algoliaSearch from "algoliasearch/lite";
import ThumbnailSection from "@/views/dashboard/favorites/ThumbnailSection";
import { recommendationsApi } from "@/services/api/recommendationsApi";

const FavoriteApiService = new FavoriteApi(),
  RetailerApiService = new RetailerApi();

export default {
  components: { ThumbnailSection },
  data() {
    return {
      loaded: false,
      algoliaClient: algoliaSearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      storeName: "",
      productList: [null, null, null, null, null],
      productsLoaded: false,
      productCount: null,

      brandList: [null, null, null, null, null],
      brandCount: null,
      brandsLoaded: false,

      recommendedBrandsList: [null, null, null, null, null],
      recommendedBrandsCount: null,
      recommendedBrandsLoaded: false,
    };
  },
  async mounted() {
    await this.fetchRecommendedBrands();
    const { data } = await RetailerApiService.getMyRetailerInfo();
    this.storeName = data.store_name;

    const products = this.$env.getOrigin() + "_products";
    FavoriteApiService.getFavoriteProductIds().then((result) => {
      const productIds = result.data.product_ids;
      this.algoliaClient
        .initIndex(products)
        .getObjects(productIds)
        .then((results, err) => {
          if (err) {
            return;
          }
          const products = results.results;
          this.productList = this.productList.map((productSlot, i) => products[i] && products[i].image);
          this.productsLoaded = true;
        });
    });
    const brands = this.$env.getOrigin() + "_brands";
    FavoriteApiService.getFavoriteBrandIds().then((result) => {
      const brandIds = result.data.brand_ids;
      this.algoliaClient
        .initIndex(brands)
        .getObjects(brandIds)
        .then((results, err) => {
          if (err) {
            return;
          }
          const brandsListData = results.results;
          this.brandList = this.brandList.map((productSlot, i) => {
            if (brandsListData[i]) {
              return brandsListData[i].thumbnail_image_url;
            }
            return false;
          });
          this.brandsLoaded = true;
        });
    });

    FavoriteApiService.getFavoriteProductsCount().then((response) => {
      this.productCount = response.data.favorite_products_count;
    });
    FavoriteApiService.getFavoriteBrandsCount().then((response) => {
      this.brandCount = response.data.favorite_brands_count;
    });

    this.loaded = true;
  },
  computed: {
    productCountMessage: function () {
      return `(${this.productCount} product${this.productCount === 1 ? "" : "s"})`;
    },
    brandCountMessage: function () {
      return `(${this.brandCount} brand${this.brandCount === 1 ? "" : "s"})`;
    },
    showRecommendations: function () {
      return this.recommendedBrandsLoaded && this.recommendedBrandsList.length !== 0;
    },
  },
  methods: {
    async fetchRecommendedBrands() {
      const retailerId = this.$session.getUserInfo().retailer_id;
      try {
        const { data } = await recommendationsApi.fetchRecommendedBrands(retailerId);
        const { brand_ids } = data || {};
        if (brand_ids) {
          this.recommendedBrandsList = brand_ids;
          this.recommendedBrandsCount = brand_ids.length;
        }
      } finally {
        this.recommendedBrandsLoaded = true;
      }
    },
  },
};
